import * as FileSaver from 'file-saver'
import moment from 'moment-timezone'
import * as XLSX from 'xlsx-js-style'
import { styleTableSheet } from 'utils/excelStyle'
import { formatDatePMBV2 } from 'utils/formatDate'

const formatPercentage = (value) => {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) {
    return '-'
  }
  return `${numeric.toFixed(2)}%`
}

export const handleDownloadExcel = async (
  data,
  setIsDownload,
  setFirstRows,
  setTotalRows,
  triggerFetch,
  queryParams,
) => {
  setIsDownload(false)
  setFirstRows(0)
  setTotalRows(0)

  setTimeout(async () => {
    try {
      setIsDownload(true)
      const totalItems = data?.totalItems || data?.items?.length || 0
      setTotalRows(totalItems)
      setFirstRows(0)

      const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      const bookType = 'xlsx'

      const exportHeader = [
        'Tanggal',
        'Nama Proses',
        'Inventori',
        'Lot ID',
        'Project',
        'Tipe Proses',
        'Dibuat oleh',
        'Raw Conversion %',
        'Benchmark %',
      ]
      const ws = XLSX.utils.book_new()
      XLSX.utils.sheet_add_aoa(ws, [exportHeader])

      const perPage = 100
      let allData = []

      if (triggerFetch && totalItems > 0) {
        const totalPages = Math.ceil(totalItems / perPage)
        let fetchedItems = 0

        for (let page = 0; page < totalPages; page++) {
          try {
            const result = await triggerFetch({
              ...queryParams,
              page,
              size: perPage,
            }).unwrap()

            const pageData = result?.items || []
            if (pageData.length === 0) break

            allData = [...allData, ...pageData]
            fetchedItems += pageData.length
            setFirstRows(Math.min(fetchedItems, totalItems))

            if (fetchedItems < totalItems) {
              await new Promise((resolve) => setTimeout(resolve, 100))
            }
          } catch (fetchError) {
            console.error(`Error fetching page ${page}:`, fetchError)
            break
          }
        }
      } else {
        allData = data?.items || []
        setFirstRows(allData.length)
      }

      const excelData = allData.map((row) => [
        row?.createdAt ? formatDatePMBV2(row.createdAt) : '-',
        row?.processingName ?? '-',
        row?.nameItems ?? '-',
        row?.lotCode ?? '-',
        row?.projectLabel ?? '-',
        row?.processingType ?? '-',
        row?.creatorName ?? '-',
        formatPercentage(row?.rawConversion),
        formatPercentage(row?.benchmark),
      ])

      XLSX.utils.sheet_add_aoa(ws, excelData, { origin: 'A2' })

      // Set column widths for better readability
      ws['!cols'] = [
        { wch: 22 }, // Tanggal
        { wch: 25 }, // Nama Proses
        { wch: 20 }, // Inventori
        { wch: 20 }, // Lot ID
        { wch: 20 }, // Project
        { wch: 18 }, // Tipe Proses
        { wch: 25 }, // Dibuat oleh
        { wch: 18 }, // Raw Conversion %
        { wch: 18 }, // Benchmark %
      ]

      styleTableSheet(ws)
      const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
      const excelBuffer = XLSX.write(wb, { bookType, type: 'array' })
      const finalData = new Blob([excelBuffer], { type: fileType })

      FileSaver.saveAs(
        finalData,
        `Laporan_Proses_${moment().format('YYYY-MM-DD')}.xlsx`,
      )

      setTimeout(() => {
        setIsDownload(false)
        setFirstRows(0)
        setTotalRows(0)
      }, 1500)
    } catch (error) {
      console.error('Export error:', error)
      setIsDownload(false)
      setFirstRows(0)
      setTotalRows(0)
    }
  }, 300)
}
